export default __webpack_public_path__ + "static/media/Portfolio.95fc9a3e.jpg";